import { StaggerItem, StaggerReveal } from "@/components/motion/StaggerReveal";

const STATS = [
    { value: "06", label: "IRL Hackathons" },
    { value: "04", label: "Rural Cities" },
    { value: "400+", label: "Builders Shipped" },
];

export default function Stats() {
    return (
        <section
            data-testid="stats-section"
            className="relative bg-zinc-950 text-white"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-20 md:py-28">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-end mb-12 md:mb-20">
                    <div>
                        <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-white/60 mb-5">
                            <span className="h-px w-8 bg-white/40" />
                            Receipts, not vibes
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-[-0.03em] leading-[0.95]">
                            Six hackathons.
                            <br />
                            Four rural towns.
                            <br />
                            <span className="text-[#E54D2E]">One community.</span>
                        </h2>
                    </div>
                    <p className="text-lg text-white/70 leading-relaxed max-w-md md:justify-self-end">
                        We’ve hosted IRL hackathons with partners like Vercel
                        across universities and rural hubs — and we’re just
                        warming up.
                    </p>
                </div>

                <StaggerReveal className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-10 border-t border-white/10 pt-10 md:pt-14">
                    {STATS.map((s) => (
                        <StaggerItem
                            key={s.label}
                            data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="group"
                        >
                            <div className="font-display text-6xl md:text-7xl lg:text-8xl font-black tracking-[-0.04em] leading-none">
                                {s.value}
                            </div>
                            <div className="mt-4 text-xs md:text-sm uppercase tracking-[0.22em] text-white/50 font-mono">
                                {s.label}
                            </div>
                        </StaggerItem>
                    ))}
                </StaggerReveal>
            </div>
        </section>
    );
}
